<template>
  <tg-layout :headerHeight="headerHeight">
    <template slot="header">
      <el-row type="flex" justify="space-between" align="center">
        <tg-search-tool @on-submit="handleSearch" :disabled="!targetName">
          <tg-date-search
            ref="dateSearch"
            size="small"
            v-model="dateRange"
            showDateRangePicker
            twoMonthLimit
            isAccountDate
          ></tg-date-search>
          <el-input
            :placeholder="$t('component.form.input.placeholder.member')"
            v-model="targetName"
            class="tg-input input-search-username"
            size="small"
            clearable
          ></el-input>
          <template slot="right"></template>
        </tg-search-tool>
        <el-row type="flex" v-show="hasData">
          <tg-button
            round
            border
            hoverBorderOnly
            theme="info"
            :loading="exporting"
            @click.native="handleExport"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-export"
                :class="{ active: scope.isHover }"
              ></i>
            </template>
            {{ $t("component.btn.export") }}
          </tg-button>
        </el-row>
      </el-row>
      <span class="fs-sm">{{ $t("note.twoMonthOnly") }}</span>
      <tg-amount-bar
        ref="amount"
        v-if="showBelowTable"
        :columns="amountColumns"
        :row="amountData"
      ></tg-amount-bar>
    </template>
    <tg-table
      v-if="showMainTable"
      ref="mainTable"
      :columns="mainColumns"
      :proxy="proxy"
      align="center"
      :fit="true"
      @cell-click="handleShowBelow"
      @on-loaded="handleTargetLoaded"
      :cell-class-name="parseCellClass"
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name v-bind="scope"></tg-user-full-name>
      </template>
      <template slot="level" slot-scope="scope">
        Lv.{{ scope.value }}
      </template>
      <template slot="cell" slot-scope="scope">
        <span
          :class="{
            'text-red': scope.value < 0,
            'text-green': scope.value > 0,
          }"
          >{{ scope.formated }}</span
        >
      </template>
    </tg-table>
    <tg-table
      v-if="showBelowTable"
      ref="belowTable"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      @sort-change="handleSortChange"
      @cell-click="handleShowBelow"
      @on-loaded="handleLoaded"
      :cell-class-name="parseCellClass"
      showPagination
    >
      <template slot="header">
        <el-row type="flex" justify="start" align="center">
          <span class="ma-r-3"
            >{{ $t("component.label.upper_level_user") }}:
          </span>
          <tg-user-full-name
            :row="target"
            :column="{ name: 'username', nickname: 'usernickname' }"
            :class="{ clickable: below && below.username != target.username }"
            @click.native="handleBelowClick(target)"
          ></tg-user-full-name>
          <template v-for="(_below, index) in belows">
            <span :key="index" class="mb-3">></span>
            <tg-user-full-name
              :key="'u' + index"
              :row="_below"
              :column="{ name: 'username', nickname: 'usernickname' }"
              @click.native="handleBelowClick(_below)"
              :class="{
                clickable: below && below.username != _below.username,
              }"
            ></tg-user-full-name>
          </template>
        </el-row>
      </template>
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name v-bind="scope"></tg-user-full-name>
      </template>
      <template slot="cell" slot-scope="scope">
        <span
          :class="{
            'text-red': scope.value < 0,
            'text-green': scope.value > 0,
          }"
          >{{ scope.formated }}</span
        >
      </template>
    </tg-table>
    <template v-if="showNodata">
      <div class="tg-bg-white">
        <tg-nodata :isNeedSearch="!isSearch"></tg-nodata>
      </div>
    </template>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgButton from "@/components/button/TgButton";
import TgAmountBar from "@/components/amount/TgAmountBar";
import TgTable from "@/components/table/TgTable";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgNodata from "@/components/TgNodata";

import apis from "@/apis";
const api = apis.tg_business.accounting;

import { convertToRows, flatColumns } from "@/utils/table";
import xlsx from "@/utils/xlsx";
import _ from "lodash";

export default {
  components: {
    TgLayout,
    TgSearchTool,
    TgDateSearch,
    TgButton,
    TgAmountBar,
    TgUserFullName,
    TgTable,
    TgNodata,
  },
  data() {
    return {
      targetName: "",
      target: null,
      dateRange: {},
      showNodata: true,
      isSearch: false,
      showMainTable: false,
      showBelowTable: false,
      amountColumns: [],
      amountData: {},
      columns: [],
      belows: [],
      below: null,
      proxy: api.getData,
      hasData: false,
      exporting: false,
    };
  },
  computed: {
    mainColumns() {
      return this.columns.map((x) => {
        return {
          ...x,
          sortable: false,
        };
      });
    },
    request() {
      return {
        searchName: this.targetName,
        ...this.dateRange,
      };
    },
    belowRequest() {
      return {
        ...this.request,
        targetName: this.below ? this.below.username : "",
        rootName: this.target.username,
      };
    },
    headerHeight() {
      return this.showBelowTable ? 160 : 100;
    },
  },
  created() {
    api.getColumns().then((response) => {
      this.columns = response.data;
      this.amountColumns = response.data.filter((x) => x.amount == true);
    });
  },
  methods: {
    parseCellClass({ column, row }) {
      if (column.columnKey == "username" && row.is_member == 1) {
        if (this.showMainTable || row.level < 8) {
          return "clickable text-primary";
        }
      }
    },
    handleSearch() {
      this.isSearch = true;
      this.showMainTable = true;
      this.showBelowTable = false;
      this.showNodata = false;
      this.belows = [];
      this.below = null;

      this.$nextTick(() => {
        this.$refs.mainTable.search(this.request);
      });
    },
    handleSortChange({ prop, order }) {
      let request = { ...this.belowRequest };
      request.sortField = prop;
      request.sortBy = order == "ascending" ? "asc" : "desc";
      this.$refs.belowTable.search(request);
    },
    handleTargetLoaded(response) {
      this.hasData = response.data.length > 0;

      if (response.data.length == 0) {
        this.showMainTable = false;
        this.showNodata = true;
      } else {
        this.target = response.data[0];
      }
    },
    fetchBelow(below) {
      this.below = { ...below };
      // this.below = {
      //   ...below,
      //   levelname:
      //     this.$t("enum.levels[" + below.level + "]") + this.$t("column.l10"),
      // };

      this.showMainTable = false;
      this.showBelowTable = true;
      this.$nextTick(() => {
        this.$refs.belowTable.search(this.belowRequest);
      });
    },
    // 點擊查詢對象，顯示該帳戶下階明細
    handleShowBelow(row, column) {
      if (column.columnKey === "username" && row.is_member == 1) {
        if (this.showMainTable || row.level < 8) {
          this.fetchBelow(row);
        }
      }
    },
    handleLoaded(response) {
      this.hasData = response.data.length > 0;
      this.amountData = response.total;

      if (!this.below) {
        return;
      }
      if (this.below.username == this.target.username) {
        this.belows = [];
      } else {
        let index = this.belows.findIndex(
          (x) => x.username === this.below.username
        );

        if (index > -1) {
          this.belows = this.belows.slice(0, index + 1);
        } else {
          this.belows.push({ ...this.below });
        }
      }
    },
    handleBelowClick(below) {
      if (this.below.username == below.username) {
        return;
      }

      this.fetchBelow(below);
    },
    handleExport() {
      this.exporting = true;
      let request = this.showMainTable ? this.request : this.belowRequest;
      let _columns = JSON.parse(JSON.stringify(this.mainColumns));
      _columns = _columns.map((x, i) => {
        x.width = i == 0 ? 180 : 140;
        return x;
      });

      let headerRow = convertToRows(_columns);
      let columns = flatColumns(_columns);
      let target = { ...this.target };
      let showBelowTable = this.showBelowTable;
      let below = this.below ? { ...this.below } : null;

      api.getData({ ...request, isExport: true }).then((response) => {
        if(response.retcode == 0){
          let data = response.data.map((row) => {
            row.username = row.username + "(" + row.usernickname + ")";
            return row;
          });

          let fileName = _.upperCase(target.username) + '-' + new Date().toISOString().replace(/[-:.]/g, "") + '-';
          let level = parseInt(data[0].level) + 1;

          if (showBelowTable) {
            //fileName += "线下第" + level + "阶会员";
            level = this.$t('enum.export.levels[' + level + ']');
            fileName += this.$t("component.export.under_level_member", {num: level});
          }

          if (level > 1 && below && below.username) {
            fileName += "(" + below.username + ")";
          }

          // fileName += "账务报表-";
          fileName += '-' + this.$t("component.export.finance");

          let ws = xlsx.makeSheet(headerRow, columns, data, response.total);
          xlsx.exportExcel(
            ws,
            fileName
          );
          this.exporting = false;
        }
      });
    },
  },
};
</script>
